import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getVendors(params) {
    return axios.get(adminPath('/vendors?') + prepareQueryString(params)).then((response) => {
      return {
        vendors: response.data.map((vendor) => an('Vendor', vendor)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/vendors/${id}`)).then((response) => an('Vendor', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/vendors/${id}`), {
        ...data,
      })
      .then((response) => an('Vendor', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/vendors'), {
        ...data,
      })
      .then((response) => an('Vendor', response.data));
  },
};
